import React from 'react';
import { connect } from 'react-redux';
import './EditContainer.scss';

import { Fire, Tools } from '../../../services'

import { Headerbar, TabsContainer, Loader, ImagesPicker } from '../../Reusable'

import FadeIn from 'react-fade-in';

const { useHistory } = require('react-router-dom')

type TabConfig = {
  title: string;
  key: string;
  status?: string;
}
type TabsConfig = {
  currentTab?: string;
  defaultTab: string;
  tabs: TabConfig[];

  onSwitchTab: (tab: any, tools: any) => void;
}

type Props = {
  id: string;
  error?: string;
  defaultCreationValue?: any;

  updateErrors?: (item: any) => any;
  onBack?: () => void;
  onFetch?: (id: string) => Promise<any>;
  onChange?: (item: any) => void;
  onSave: any;//(item: any) => void;
  onRemove: (item: any) => void;
  renderContent: (tools: any) => any;
  renderTitle?: (tools: any) => any;
  renderTabs?: (item: any) => TabsConfig;
}
const EditContainer: React.FC<Props> = (props) => {

  const [item, setItem] = React.useState<any>(props.defaultCreationValue || {})
  const [last, setLast] = React.useState<any>(null)
  const [loading, setLoading] = React.useState(false)
  const [saving, setSaving] = React.useState(false)
  const [changed, setChanged] = React.useState(false)
  const [categories, setCategories] = React.useState<any[]>([])

  const history = useHistory()
  const id = props.id
  
  const refresh = async () => {
    if (!props.onFetch)
      return;
    setLoading(true)
    try {
      const element = await props.onFetch(id)
      if (!element)
        throw Error("L'élement n'existe pas ou plus")
      setItem(element)
      setLast({ ...element })
    } catch (err) {
      console.warn(err)
    }
    setLoading(false)
  }

  React.useEffect(() => {
    setItem(props.defaultCreationValue || {})
    if (id !== 'new') {
      refresh()
    }
  }, [id])

  const cancel = () => {
    if (props.onBack)
      props.onBack()
    else
      history.goBack()
  }

  const onChange = (key: string, value: any) => {
    const newObject: any = {
      ...item,
    }
    newObject[key] = value
    setItem(newObject)
    setChanged(true)

    if (props.onChange)
      props.onChange(newObject)
  }

  const save = async () => {
    setSaving(true)
    try {
      await props.onSave(item, tools)
      setChanged(false)
    } catch (err) {
      console.warn(err)
    }
    setSaving(false)
  }

  const remove = async () => {
    setSaving(true)
    try {
      await props.onRemove(item)
    } catch (err) {
      console.warn(err)
    }
    setSaving(false)
  }
  
  const reset = () => {
    setChanged(false)
    setItem({ ...last })
  }

  const renderTabs = props.renderTabs ? props.renderTabs(item) : undefined
  const fadeKey = renderTabs ? (renderTabs.currentTab || renderTabs.defaultTab) : 'none'
  const errors: any = props.updateErrors ? props.updateErrors(item) : {}

  const tools = {
    item,
    tab: renderTabs ? (renderTabs.currentTab || renderTabs.defaultTab) : null,
    onChange,
    setItem,
    changed,
    setChanged,
    saving,
    setSaving,
    save,
    remove,
    errors: errors,
    error: props.error,
    reset,
  }
  
  return (
    <div className="wrapper">
      <Headerbar
        title={props.renderTitle ? props.renderTitle(tools) : id === 'new' ? 'Nouveau' : item.name}
        renderButtons={() => (
          <button
            type="button"
            className="btn btn-outline-danger"
            onClick={cancel}
            disabled={saving}
            >
            Retour
          </button>
        )}
        />
      <div className="content-wrapper">
        <div className="content">
          <div className="container-fluid edit-container">

            { loading ? (
              <Loader />
            ) : (
              <React.Fragment>
                { id !== 'new' && renderTabs &&
                  <FadeIn>
                    <TabsContainer
                      tab={renderTabs.currentTab || renderTabs.defaultTab}
                      tabs={renderTabs.tabs}
                      onSelect={(tab) => renderTabs.onSwitchTab(tab, tools)}
                      />
                  </FadeIn>
                }

                { props.error && props.error.length &&
                  <div className="card">
                    <div className="card-header">Erreur</div>
                    <div className="card-body">
                      <div className="text-danger">{props.error}</div>
                    </div>
                  </div>
                }
                
                <FadeIn key={'fade-' + fadeKey}>
                  {props.renderContent(tools)}
                </FadeIn>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditContainer